import KeyFavicon from '@panel/commons/assets/favicon/favicon.svg';
import UrbFavicon from '@panel/commons/assets/favicon/favicon_urb.svg';
import CMFavicon from '@panel/commons/assets/favicon/favicon_cm.webp';
import VAFavicon from '@panel/commons/assets/favicon/favicon_va.svg';

const useFavicon = () => {
  const favicon = document.getElementById('dynamic-favicon');
  const site = process.env.REACT_APP_BUILD_SITE;

  favicon.href = KeyFavicon;

  if (site === 'UBPE') {
    favicon.href = UrbFavicon;
  } else if (site === 'CMBR') {
    favicon.href = CMFavicon;
  } else if (site === 'VAMX') {
    favicon.href = VAFavicon;
  }
};

export { useFavicon };
